import { HStack, Select, Flex } from '@chakra-ui/react'
import Label from 'shared/components/Label'
import { FC } from 'react'
import { IVideoPlatform } from 'shared/types'

type Props = {
  label?: string
  value?: IVideoPlatform
  onChange: (v: IVideoPlatform) => void
}

const VideoPlatformSelect: FC<Props> = ({
  label = 'Видео платформа',
  value,
  onChange
}) => {
  return (
    <HStack w='full' align='center' spacing={2} justify={'space-between'}>
      <Label>{label}</Label>
      <Flex>
        <Select
          value={value || 'center'}
          onChange={e => onChange(e.target.value as IVideoPlatform)}
          variant={'solid'}
          size='xs'
        >
          <option value={IVideoPlatform.VIMEO}>Vimeo</option>
          <option value={IVideoPlatform.YOUTUBE}>Youtube</option>
        </Select>
      </Flex>
    </HStack>
  )
}

export default VideoPlatformSelect
